/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcexamtemplate')
    .component('fieldgroupname', {
      restrict: 'E',
      bindings: {
        fgname: '=',
        ondone: '&'
      },
      template: `
          <div class="input-group">
            <span class="input-group-btn">
              <button class="btn btn-danger" type="cancel" uib-tooltip="Abbrechen"  ng-click="vm.cancel()"><i class="fa fa-remove"></i></button>
            </span>
            <input type="text" ng-model="vm.tmpfgname" class="form-control" placeholder="Neuen Namen eingeben ...">
            <span class="input-group-btn">
              <button class="btn btn-success" type="submit" uib-tooltip="Kategorie/Feldgruppe umbenennen" ng-click="vm.save()"><i class="fa fa-check"></i></button>
            </span>
          </div>
      `,
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.tmpfgname = angular.copy(vm.fgname);
            vm.lastfgname = angular.copy(vm.fgname);
          };

          function save() {
            if (!angular.equals(vm.tmpfgname, vm.lastfgname)) {
              vm.fgname = angular.copy(vm.tmpfgname);
              vm.ondone();
            }
          }

          function cancel() {
            vm.fgname = angular.copy(vm.lastfgname);
            vm.ondone();
          }

        }] // controller
    }); // component

// klammerfriedhof
}());